import api from '../../lib/api';

export const getReferral = referralId =>
  function get(dispatch) {
    /**
  {
    type: 'GET_CLIENTS',
  }
  * */
    api.getReferral(referralId, (error, response) => {
      if (error) {
        return dispatch(getReferralError(error));
      }
      return dispatch(getReferralSuccess(response.data));
    });
  };
export const getReferralSuccess = data => ({
  type: 'GET_REFERRAL_SUCCESS',
  data,
});

export const getReferralError = msg => ({
  type: 'GET_REFERRAL_ERROR',
  msg,
});



// WEBPACK FOOTER //
// ./src/Actions/DropDown/getReferral.js